import { useNavigate } from "react-router-dom";
import { airlineLogos } from "../../constants/constant";
import React from "react";
import { CommissionValue, passenger } from "@/constants/types";
import { calculateCommission } from "../../constants/helper";
import { useCommission } from "@/services/customHooks/useCommission";
import { userInfo } from "node:os";
import { useGlobalState } from "../../services/context/AuthContext";
type FlightData = {
  origin: string;
  destination: string;
  departureTime: string;
  arrivalTime: string;
  fare: number;
  flightName: string;
  flightCode: string;
  airlineName: string;
};
type FlightDetailRoundTripCardProps = {
  outBoundItem: FlightData;
  inBoundItem: FlightData;
  outBoundData: any;
  inBoundData: any;
  travellersDetail: passenger;
  traceId?: string;
  ruleId?: string;
  inboundCommission?: number;
  outboundCommission?: number;
};

const FlightDetailRoundTripCard = ({
  traceId,
  outBoundItem,
  inBoundItem,
  inBoundData,
  outBoundData,
  travellersDetail,
  ruleId,
  inboundCommission,
  outboundCommission,
}: FlightDetailRoundTripCardProps) => {
  const totalFare =
    outBoundItem.fare +
    inBoundItem.fare +
    (outboundCommission ?? 0) +
    (inboundCommission ?? 0);

  const outBoundFlightImg = airlineLogos[outBoundItem.airlineName];
  const inBoundFlightImg = airlineLogos[inBoundItem.airlineName];
  const navigation = useNavigate();
  const tdeatil = {
    ...travellersDetail,

    adultFare:
      (inBoundData?.Fare?.PaxFares?.filter(
        (i: any) => i?.PaxType === 0
      )?.reduce((sum: number, i: any) => sum + (i?.BasicFare ?? 0), 0) ?? 0) +
      (outBoundData?.Fare?.PaxFares?.filter(
        (i: any) => i?.PaxType === 0
      )?.reduce((sum: number, i: any) => sum + (i?.BasicFare ?? 0), 0) ?? 0),

    childFare:
      (inBoundData?.Fare?.PaxFares?.filter(
        (i: any) => i?.PaxType === 1
      )?.reduce((sum: number, i: any) => sum + (i?.BasicFare ?? 0), 0) ?? 0) +
      (outBoundData?.Fare?.PaxFares?.filter(
        (i: any) => i?.PaxType === 1
      )?.reduce((sum: number, i: any) => sum + (i?.BasicFare ?? 0), 0) ?? 0),

    infantFare:
      (inBoundData?.Fare?.PaxFares?.filter(
        (i: any) => i?.PaxType === 2
      )?.reduce((sum: number, i: any) => sum + (i?.BasicFare ?? 0), 0) ?? 0) +
      (outBoundData?.Fare?.PaxFares?.filter(
        (i: any) => i?.PaxType === 2
      )?.reduce((sum: number, i: any) => sum + (i?.BasicFare ?? 0), 0) ?? 0),

    totalFare:
      (inBoundData?.Fare?.TotalFareWithOutMarkUp ?? 0) +
      (outBoundData?.Fare?.TotalFareWithOutMarkUp ?? 0),

    totalTax:
      (inBoundData?.Fare?.TotalTaxWithOutMarkUp ?? 0) +
      (outBoundData?.Fare?.TotalTaxWithOutMarkUp ?? 0),
  };
  const { userInfo } = useGlobalState();
  const isInvalidDateSelection = () => {
    if (!outBoundItem?.departureTime || !inBoundItem?.departureTime)
      return false;

    const outboundDateTime = outBoundItem.arrivalTime;
    const inboundDateTime = inBoundItem.departureTime;
    console.log("outboundDateTime", outboundDateTime);
    console.log("inboundDateTime", inboundDateTime);
    if (
      inboundDateTime <= outboundDateTime ||
      outBoundItem?.departureTime >= outBoundItem?.arrivalTime
    ) {
      alert("Invalid selection: Return time must be after arrival time");
    }
    return (
      inboundDateTime <= outboundDateTime ||
      outBoundItem?.departureTime >= outBoundItem?.arrivalTime
    ); // invalid if return starts before or same as departure
  };

  return (
    <>
      <div className="sticky_bottom ">
        <div className="container">
          <div className="row hidden-xs">
            <div className=" col-md-4 stk_btm_section">
              <div className="d-flex justify-content-between">
                <div className=" ">
                  <div>
                    <img width={32} src={outBoundFlightImg} alt="flightImg" />
                  </div>
                  <span className="font-11 pull-left">
                    <span className="make_blockElm airline-catcher">
                      <span className="ng-binding">
                        {outBoundItem?.flightCode}
                      </span>
                    </span>
                  </span>
                </div>

                <div className="">
                  <p className="stk_btm_fltTime ng-binding">
                    {outBoundItem.departureTime}
                  </p>
                  <p className="stk_btm_sector ng-binding">
                    {outBoundItem.origin}
                  </p>
                </div>
                <div className=" no-padd hidden-sm stk_btm_arrowWrapper">
                  <span className="stk_btm_arrow" />
                </div>
                <div className=" ">
                  <p className="stk_btm_fltTime ng-binding">
                    {outBoundItem.arrivalTime}
                  </p>
                  <p className="stk_btm_sector ng-binding">
                    {outBoundItem.destination}
                  </p>
                </div>
                <div className="">
                  <p className="">
                    {userInfo?.currencyCode ?? "AED"}{" "}
                    {/* <i className="fa-solid fa-indian-rupee-sign"></i> */}
                    <span className="">
                      {outBoundItem.fare + (outboundCommission ?? 0)}
                    </span>
                  </p>

                  <div className="clr" />
                </div>
              </div>
            </div>
            <div className=" col-md-4 stk_btm_section">
              <div className="d-flex justify-content-between">
                <div className="" style={{ width: "auto" }}>
                  <div>
                    <img width={32} src={inBoundFlightImg} alt="flightImg" />
                  </div>
                  <span className="font-11 pull-left">
                    <span className="make_blockElm airline-catcher">
                      <span className="ng-binding">
                        {inBoundItem.flightCode}
                      </span>
                    </span>
                  </span>
                </div>

                <div className="">
                  <p className="stk_btm_fltTime ng-binding">
                    {inBoundItem.departureTime}
                  </p>
                  <p className="stk_btm_sector ng-binding">
                    {inBoundItem.origin}
                  </p>
                </div>
                <div className=" no-padd hidden-sm stk_btm_arrowWrapper">
                  <span className="stk_btm_arrow" />
                </div>
                <div className="">
                  <p className="stk_btm_fltTime ng-binding">
                    {inBoundItem.arrivalTime}
                  </p>
                  <p className="stk_btm_sector ng-binding">
                    {inBoundItem.destination}
                  </p>
                </div>
                <div className=" text-right no-padd-lt">
                  <p className="stk_btm_price ng-scope">
                    {userInfo?.currencyCode ?? "AED"}{" "}
                    {/* <i className="fa-solid fa-indian-rupee-sign"></i> */}
                    <span className="ng-binding">
                      {inBoundItem.fare + (inboundCommission ?? 0)}
                    </span>
                  </p>

                  {/* <p className="font_12">
                    <a className="fare_btn-emt-round anchor_detls underline">
                      Details
                    </a>
                  </p> */}
                </div>
              </div>
            </div>
            <div className=" col-md-4 ">
              <div className="d-flex justify-content-between">
                <div className=" ng-scope">
                  <span className="ft14nv">
                    Grand Total: {userInfo?.currencyCode ?? "AED"}{" "}
                    <span className="ng-binding ng-scope">{totalFare}</span>
                  </span>
                  <div className="clr" />
                  <p className="stk_btm_price " style={{ float: "left" }}>
                    {" "}
                    {/* <i className="fa-solid fa-indian-rupee-sign"></i> */}
                  </p>
                </div>
                {isInvalidDateSelection() ? (
                  <div className="flight-total-error-msg">
                    Please select valid date selection (return date must be
                    after departure date)
                  </div>
                ) : (
                  <div
                    id="BtnBookNow"
                    className="book-btn ng-pristine ng-untouched ng-valid ng-scope ng-empty"
                    onClick={() =>
                      navigation("/flightDetail", {
                        state: {
                          outBoundItem,
                          inBoundItem,
                          inBoundData,
                          outBoundData,
                          travellersDetail: tdeatil,
                          traceId: traceId,
                          ruleId,
                          commission:
                            (inboundCommission ?? 0) +
                            (outboundCommission ?? 0),
                        },
                      })
                    }
                  >
                    Book Now
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FlightDetailRoundTripCard;
